export default "__VITE_ASSET__DuKbWqCQ__"